import { render, staticRenderFns } from "./InsightConnectionPanel.vue?vue&type=template&id=28316cfe&scoped=true"
import script from "./InsightConnectionPanel.vue?vue&type=script&lang=js"
export * from "./InsightConnectionPanel.vue?vue&type=script&lang=js"
import style0 from "./InsightConnectionPanel.vue?vue&type=style&index=0&id=28316cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28316cfe",
  null
  
)

export default component.exports